import React from "react";
import ZenDeskBtn from "../../ui/zend-desk";

const HelpChatTel = ({ data, className }) => {
    const { text, chatText, text2, telText } = data;
    const css = `text-center text-sm ${className}`;
    return (
        <div className={css}>
            {text}{" "}
            {chatText && (
                <ZenDeskBtn className="text-skin-primary">
                    {chatText}
                </ZenDeskBtn>
            )}{" "}
            {text2}{" "}
            {telText && (
                <a className="text-skin-primary" href={`tel:${telText}`}>
                    {telText}
                </a>
            )}
        </div>
    );
};

export default HelpChatTel;
